import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EnumService {
  getEnumDropdownOptions(
    enumInstance: any,
    sortAlphabetically: boolean = false,
  ): Array<{ label: string; value: string }> {
    const options = Object.keys(enumInstance).map((key) => ({
      value: key,
      label: enumInstance[key],
    }));

    if (sortAlphabetically) {
      options.sort((a, b) => a.label.localeCompare(b.label));
    }

    return options;
  }

  getEnumKeyByValue<T extends Record<string, string | number>>(
    enumObj: T,
    value: T[keyof T],
  ): keyof T | undefined {
    return Object.keys(enumObj).find(
      (key) => enumObj[key as keyof T] === value,
    ) as keyof T | undefined;
  }
}
